<template>
  <div>
    <p class="text-xl font-bold mb-4">{{ t("title") }}</p>
    <div class="overflow-x-auto shadow-lg bg-gray-50 rounded-lg">
      <table class="table-auto w-full text-left border-collapse text-sm">
        <thead class="bg-gray-100">
          <tr>
            <th class="px-4 py-3 text-gray-600 font-semibold w-12"></th>
            <th class="px-4 py-3 text-gray-600 font-semibold">{{ t("store_name") }}</th>
            <th class="px-4 py-3 text-gray-600 font-semibold text-right">
              {{ t(`challenge.counting.${countingMethod}.column`) }}
            </th>
            <th class="px-4 py-3 text-gray-600 font-semibold text-right">{{ t("total_reward") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="store in windowedStores"
            :key="store.storeId"
            :class="isCurrentStore(store) ? 'ring-2 ring-primary' : ''"
          >
            <td class="px-4 py-2">{{ store.rank }}</td>
            <td class="px-4 py-2 font-medium">
              {{ store.salesChannel }}
              <span v-if="isCurrentStore(store)" class="text-xs text-primary-dark ml-1">
                ({{ t("current_store") }})
              </span>
            </td>
            <td class="px-4 py-2 text-right">{{ store.salesCount }}</td>
            <td class="px-4 py-2 text-right font-semibold">{{ formatPrice(store.totalReward) }}</td>
          </tr>
        </tbody>
      </table>
      <button
        v-if="hasMore"
        class="w-full py-2 text-sm text-primary-dark font-medium hover:bg-gray-100 transition-colors"
        @click="expanded = !expanded"
      >
        {{ expanded ? t("show_less") : t("show_more") }}
      </button>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { formatPrice } from "@estaly/ui";

const WINDOW_SIZE = 5;

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    storeRankings: {
      type: Object,
      required: true,
    },
    currentStoreId: {
      default: null,
    },
    countingMethod: {
      type: String,
      default: "plan_sales",
    },
  },

  data() {
    return {
      expanded: false,
    };
  },

  computed: {
    allStores() {
      return this.storeRankings.stores || [];
    },

    windowedStores() {
      if (this.expanded) return this.allStores;
      if (this.allStores.length <= WINDOW_SIZE) return this.allStores;

      const currentIndex = this.allStores.findIndex((s) => this.isCurrentStore(s));
      if (currentIndex === -1) return this.allStores.slice(0, WINDOW_SIZE);

      const half = Math.floor(WINDOW_SIZE / 2);
      let start = currentIndex - half;
      let end = currentIndex + half + 1;

      if (start < 0) {
        start = 0;
        end = WINDOW_SIZE;
      } else if (end > this.allStores.length) {
        end = this.allStores.length;
        start = Math.max(0, end - WINDOW_SIZE);
      }

      return this.allStores.slice(start, end);
    },

    hasMore() {
      return this.allStores.length > WINDOW_SIZE;
    },
  },

  methods: {
    formatPrice,

    isCurrentStore(store) {
      return store.storeId === this.currentStoreId;
    },
  },
};
</script>

<i18n src="./TieredChallengeNetworkRanking.i18n.json"></i18n>
